import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { AppSettings } from 'app/modules/shared/app.settings';
import { LoaderService } from 'app/modules/shared/components/loader/loader.service';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { RestApiService } from 'app/modules/shared/services/rest-api.service';
import { StorageService } from 'app/modules/shared/services/storage.service';
import { UiService } from 'app/modules/shared/services/ui.service';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ManageOpenShiftsService } from '../../services/manage-open-shifts.service';

@Component({
  selector: 'app-manage-shifts-team-members-list',
  templateUrl: './manage-shifts-team-members-list.component.html',
  styleUrls: ['./manage-shifts-team-members-list.component.scss']
})
export class ManageShiftsTeamMembersListComponent implements OnInit {
  subject: Subject<any>;
  hideFilterSection: boolean;
  isLoaded = false;
  disableLoadMore = false;
  isSwitcher = false;
  memberShiftAvailabilityList: any[] = [];
  memberShiftAvailabilityAndTimeOffList: any[] = [];
  teamShiftAvailabliltyDropdown: any[] = [];
  userList: any[] = [];
  searchedTeam = '';
  sentSearchedTeam = '';
  currentPage = 'weekView';
  date = new Date();
  maxDate = new Date();
  minDate = this.date;
  selectedAvailability = '';
  selectedRole = '';
  providerId = '';
  dayOffset = AppSettings.ONE_DAY_IN_MILISECOND;
  offset = 0;
  timezoneAbbr = '';
  openProviderScheduleDialog = false;
  repeatSchedule = false;
  repeatScheduleOptions = [
    { label: 'Specific Date', value: false },
    { label: 'For Next 3 Months ', value: true }
  ];
  SuccessErrorDialog = false;
  scheduleProviderFileName = '';
  scheduleproviderExcelId = '';
  scheduleProviderTemplate = this.commonService.getTenantConfigValue(AppSettings.PROVIDER_SCHEDULE_TEMPLATE);
  importForOptions = [
    { label: 'Specific Date', value: 10 },
    { label: 'Custom Range', value: 0 }
  ];
  weeksOptions = [
    { label: '1 Week', value: 1 },
    { label: '2 Weeks', value: 2 },
    { label: '3 Weeks', value: 3 },
    { label: '4 Weeks', value: 4 }
  ];
  Form = new FormGroup({});
  cDateRange: string;
  scheduleTimezoneName = 'CST';
  fileInportMsg = 'File imported to the system successfully';
  successErrorArray: any;
  successErrorPopUp = false;
  importErrorPopUp = false;
  fileInportHeader = 'File Imported Successfully';
  dateFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  } as const;
  openImportProviderDialog = false;
  chooseLabel: any;
  exportPopup = false;
  providerIdExport: any = '';
  fromDate = new Date();
  toDate: Date = new Date(new Date().setHours(23, 59, 59, 999));
  dateFormat;
  providerNameListExport: any[];
  roleId: any;
  loggedInUsername: any;
  userInfo: any;
  loginUserId: any;
  dateDiffFlag = true;
  exportUrlViaEmail = '';
  userEmail: any;
  userName: any;
  timezoneOptions = [
    // {
    //   label: 'Please select',
    //   value: ''
    // },
    // {
    //   label: 'EST',
    //   value: 'America/New_York'
    // },
    {
      label: 'CST',
      value: 'America/Chicago'
    },
    //   {
    //     label: 'PST',
    //     value: 'America/Los_Angeles'
    // }
  ];
  onProviderInportDialog = false;
  filterSavedFlag: Boolean = false;
  filterLocalData: any;
  showRole: Boolean = false;
  roles: any = [];
  userRoleIds: any[] = [];
  providerList: any[] = [];
  serviceRegionList: any[] = [];
  selectedServiceRegionIds: any[] = [];
  url: any = '';
  selectedRoleId: any;
  FilterDataFlag: any;
  isDateChanged: Boolean = false;
  disableProvider = false;
  currentDate = new Date();
  constructor(private storageService: StorageService,
    private router: Router, private commonService: CommonBindingDataService,
    private restApiService: RestApiService, private formBuilder: FormBuilder,
    private loaderService: LoaderService, private manageOpenShiftsService: ManageOpenShiftsService,
    private uiService: UiService, ) {
    this.subject = new Subject();
    const d = new Date(new Date().setHours(0, 0, 0, 0));
    d.setDate(d.getDate() + 30);
    this.toDate = d;
  }

  ngOnInit(): void {
    this.cDateRange = this.commonService.getYearRangeForCalendar();
    this.chooseLabel = this.commonService.getLabel('label_choose_file');
    this.maxDate = new Date(this.maxDate.getTime() + (60 * 24 * 3600000));
    const tagsData = this.storageService.getItem(AppSettings.TAG_DATA);
    this.timezoneAbbr = this.commonService.getTenantConfigValue(AppSettings.TIMEZONE_ABBR);
    this.userInfo = this.storageService.getItem(AppSettings.USER_DETAILS);
    if (this.userInfo) {
      this.loginUserId = this.userInfo.id;
      this.userEmail = this.userInfo.email;
      this.userName = this.userInfo.firstName + ' ' + this.userInfo.lastName;
    }
    this.applyProviderRoleScope();
    this.loadServiceRegions();
    if (tagsData == null) {
      const localTagData = localStorage.getItem('localTagdata');
      this.setDropdownValues(JSON.parse(localTagData));
    } else {
      this.setDropdownValues(tagsData);
      localStorage.removeItem('localTagdata');
    }
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentPage = event.url.split('/')[3] === 'week' ? 'weekView' : 'dayView';
      }
    });
    this.subject.pipe(debounceTime(500)).subscribe(() => {
      this.sentSearchedTeam = this.searchedTeam;
    });
    this.validateForm();
    this.dateFormat = this.commonService.getDateFormat();


    this.loggedInUsername = this.userInfo.username;
    this.roleId = sessionStorage.getItem('userRoleId');
    // if (this.roleId !== '6' && this.roleId !== '11') {
    //   setTimeout(() => {
    //     this.getProvider();
    //   }, 500)
    // }
    this.getRoles();
    setTimeout(() => {
    this.getFilter();
   }, 200);
    const filterObj: any = this.storageService.getItem(AppSettings.FILTER_DETAILS_TEAM_MEMBER);
    this.filterLocalData = filterObj;
    const savedFilterLocal = localStorage.getItem('teamMemberFilterPresent');
    const localData = JSON.parse(savedFilterLocal);
    if (localData) {
      this.filterLocalData = localData.filterData;
    }

  }

  setDropdownValues(tagsData) {
    tagsData.teams_member_availability.forEach(element => {
      this.memberShiftAvailabilityList.push({ label: element.tagValue, value: this.convertToCssClass(element.tagValue) });
    });
    this.memberShiftAvailabilityAndTimeOffList.push({ label: this.commonService.getLabel('All'), value: '' });
    tagsData.shift_availability.forEach(element => {
      this.memberShiftAvailabilityAndTimeOffList.push({ label: element.tagValue, value: element.tagId });
    });
    if (this.commonService.getGlobalConfigByKey(AppSettings.GLOBAL_CONFIGRATION.PTO)?.value) {
      tagsData.leave_type.forEach(element => {
        this.memberShiftAvailabilityAndTimeOffList.push({ label: element.tagValue, value: element.tagId });
      });
    } else {
      this.memberShiftAvailabilityAndTimeOffList.pop();
    }
    tagsData.team_member_shifts.forEach(element => {
      this.teamShiftAvailabliltyDropdown.push({ label: element.displayValue, value: element.tagValue });
    });
    if (this.disableProvider) {
      // this.userList.push({ label: this.commonService.getLabel('All'), value: '' });
      tagsData.open_shift_user_type.forEach(element => {
        if (element.tagValue === 'Mobile App') {
          this.userList.push({ label: element.tagValue, value: element.tagId });
        }
      });
      this.selectedRole = '10';
    } else {
      this.userList.push({ label: this.commonService.getLabel('All'), value: '' });
      tagsData.open_shift_user_type.forEach(element => {
        this.userList.push({ label: element.tagValue, value: element.tagId });
      });
    }
    if (!this.commonService.getGlobalConfigByKey(AppSettings.GLOBAL_CONFIGRATION.MANAGE_SHIFT)?.value) {
      this.userList.pop();
    }
    this.getProvider();
  }


  getProvider() {
    // this.providerList.push({ label: this.commonBindingDataService.getLabel('All'), value: '' });
    this.manageOpenShiftsService.getProvider().subscribe(results => {
      const providerData = results;
      this.providerList.push({ label: this.commonService.getLabel('All'), value: '' });
      for (let i = 0; i < providerData.length; i++) {
        if (providerData[i].providerName !== null) {
          this.providerList.push({ label: providerData[i].providerName, value: providerData[i].id });
        }
      }
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }

  loadMore() {
    this.offset += 10;
  }

  goToToday() {
    if (this.minDate.getTime() !== this.date.getTime()) {
      this.date = new Date();
      this.minDate = this.date;
    }
  }

  getTotalCount(totalCount: any) {
    this.disableLoadMore = ((this.offset + 10) > totalCount) ? true : false;
  }

  goToNextWeek() {
    if (this.currentPage === 'weekView') {
      // if (this.maxDate.getTime() > this.date.getTime()) {
        const date = new Date();
        date.setTime(this.date.getTime() + (7 * this.dayOffset));
        this.date = date;
        this.offset = 0;
      // }
    } else {
      // if (this.maxDate.getTime() > this.date.getTime()) {
        const date = new Date();
        date.setTime(this.date.getTime() + (1 * this.dayOffset));
        this.date = date;
        this.offset = 0;
      // }
    }
  }

  goToPreviousWeek() {
    if (this.currentPage === 'weekView') {
      // if (this.minDate.getTime() !== this.date.getTime()) {
      const date = new Date();
      date.setTime(this.date.getTime() - (7 * this.dayOffset));
      this.date = date;
      this.offset = 0;
      // }
    } else {
      // if (this.minDate.getTime() !== this.date.getTime()) {
      const date = new Date();
      date.setTime(this.date.getTime() - (1 * this.dayOffset));
      this.date = date;
      this.offset = 0;
      // }
    }
  }

  onResetFilter() {
    if (this.filterSavedFlag) {
      this.manageOpenShiftsService.resetFilter(this.loginUserId, 'TEAM_MEMBER_FILTER').subscribe(results => {
        this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
        this.filterSavedFlag = false;
        localStorage.removeItem('teamMemberFilterPresent');
        this.storageService.removeItem(AppSettings.FILTER_DETAILS_TEAM_MEMBER);
      }, (error) => {
        this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
      });
    }
    this.offset = 0;
    this.date = new Date();
    this.minDate = this.date;
    this.searchedTeam = '';
    this.sentSearchedTeam = '';
    this.selectedAvailability = '';
    if (!this.disableProvider) {
      this.providerId = '';
    } else {
      this.providerId = this.loginUserId;
    }
    this.selectedServiceRegionIds = [];
    this.selectedRole = '';
    this.userRoleIds = [];
    this.showRole = false;
    this.isDateChanged = false;
    this.loadServiceRegions();
  }

  changeFilter() {
    this.offset = 0;
    this.isDateChanged = true;
  }

  changeUserFilter() {
    this.offset = 0;
    // this.isDateChanged = true;
    if (this.selectedRole === '20') {
      this.showRole = true;
    } else {
      this.showRole = false;
    }
  }

  changeRoleFilter() {
    this.offset = 0;
  }

  searchTeam() {
    this.subject.next();
    this.offset = 0;
  }

  updateOffset(offset: any) {
    this.offset = offset;
  }

  changeTab() {
    this.isSwitcher = !this.isSwitcher;
    const isTab = this.isSwitcher ? 'day' : 'week';
    this.router.navigate(['/manage-shift/team-members/', isTab]);
  }

  hideFilter(event) {
    this.hideFilterSection = event === true ? true : false;
  }

  shiftUpload() {
    this.openProviderScheduleDialog = true;
    this.repeatSchedule = false;
    // this.scheduleTimezoneName = '';
    this.scheduleProviderFileName = '';
    this.scheduleproviderExcelId = '';
  }

  providerSchedulePopupCancel() {
    this.openProviderScheduleDialog = false;
    this.SuccessErrorDialog = false;
    this.repeatSchedule = false;
    // this.scheduleTimezoneName = '';
    this.scheduleProviderFileName = '';
  }

  onUploadScheduleProviderExcel(response) {
    this.scheduleProviderFileName = response.originalFileName;
    this.scheduleproviderExcelId = response.fileId;
  }

  providerScheduleTemplate() {
    let url = '';
    url = `/secure/file/${this.scheduleProviderTemplate}`;
    return this.restApiService.excel('', url, 'Sample_User_Availability.xlsx', 'page-center');
  }

  onChangeImportForOptions() {
    const importForType = this.Form.controls.importFor.value;
    if (importForType === 0) {
      this.Form.controls.weeksInExcel.setValue('');
      this.Form.controls.weeksInExcel.setValidators([Validators.required]);
      this.Form.controls.importTill.setValue('');
      this.Form.controls.importTill.setValidators([Validators.required]);
    } else {
      this.Form.controls.weeksInExcel.setValue('');
      this.Form.controls.weeksInExcel.setValidators([]);
      this.Form.controls.importTill.setValue('');
      this.Form.controls.importTill.setValidators([]);
    }
    this.Form.controls.weeksInExcel.updateValueAndValidity();
    this.Form.controls.importTill.updateValueAndValidity();
  }

  validateForm() {
    this.Form = this.formBuilder.group({
      importFor: ['', [
        Validators.required,
      ]],
      weeksInExcel: ['', [
        // Validators.required,
      ]],
      importTill: ['', [
        // Validators.required,
      ]]
    });
  }

  closeErrorPopUp() {
    this.fileInportHeader = '';
    this.fileInportMsg = '';
    this.importErrorPopUp = false;
    this.resetImportAvailabilityFields();
  }

  closeSuccessErrorPopUp() {
    this.fileInportHeader = '';
    this.fileInportMsg = '';
    this.successErrorPopUp = false;
    this.resetImportAvailabilityFields();
  }

  resetImportAvailabilityFields() {
    this.Form.reset();
  }

  uploadPopupCancel() {
    this.openImportProviderDialog = false;
    this.SuccessErrorDialog = false;
  }

  doValidSave() {
    if (this.Form.valid) {
      return false;
    } else {
      return true;
    }
  }

  // uploadScheduleProviderExcelData() {
  //   const data = {
  //     repeatSchedule: this.repeatSchedule,
  //     fileName: this.scheduleproviderExcelId,
  //     scheduleTimezoneName: this.scheduleTimezoneName
  //     // fileName: this.scheduleproviderExcelId,
  //     // scheduleTimezoneName: this.scheduleTimezoneName,
  //     // importType: this.Form.controls.importFor.value,
  //     // noOfWeeks: this.Form.controls.weeksInExcel.value,
  //     // importTillDate: this.Form.controls.importTill.value ?
  //     // this.Form.controls.importTill.value?.toLocaleDateString('en-US', this.dateFormatOptions) : null
  //   };

  //   this.scheduleProviderFileName = '';
  //   this.openProviderScheduleDialog = false;
  //   this.loaderService.showSecond('true');

  //   this.manageOpenShiftsService.importExcelScheduleProvider(data).subscribe(result => {
  //   // this.manageOpenShiftsService.importExcelScheduleProviderV2(data).subscribe(result => {
  //     // this.uiService.showMessage(result.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
  //     // this.fileInportHeader = 'File Imported Successfully';
  //     this.fileInportMsg = result?.message;
  //     this.successErrorArray = result;
  //     this.successErrorArray.status ? this.fileInportHeader = 'File Imported Successfully' : this.fileInportHeader = 'File Import Error';
  //     this.successErrorPopUp = true;
  //     // this.onProviderInportDialog = true;
  //     this.loaderService.hideSecond();
  //     // this.reloadGrid();
  //     this.repeatSchedule = false;
  //     this.scheduleTimezoneName = '';
  //     // this.scheduleTimezoneName = '';
  //   }, (error) => {
  //     // this.onProviderInportDialog = true;
  //     this.fileInportHeader = 'File Import Error';
  //     this.loaderService.hideSecond();
  //     //this.fileInportMsg = error.general[0].message;
  //     this.fileInportMsg = error?.message ? error?.message : error.general[0].message;
  //     this.importErrorPopUp = true;
  //     this.repeatSchedule = false;
  //     this.scheduleTimezoneName = '';
  //     //   this.scheduleTimezoneName = '';
  //     //this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
  //     this.loaderService.hideSecond();

  //   });
  // }

  uploadScheduleProviderExcelData() {
    const data = {
      repeatSchedule: this.repeatSchedule,
      fileName: this.scheduleproviderExcelId,
      scheduleTimezoneName: this.scheduleTimezoneName
    };

    this.scheduleProviderFileName = '';
    this.openProviderScheduleDialog = false;
    this.loaderService.showSecond('true');

    this.manageOpenShiftsService.importExcelScheduleProvider(data).subscribe(result => {
      this.uiService.showMessage(result.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
      this.fileInportHeader = 'File Imported Successfully';
      this.fileInportMsg = result.general[0].message;
      this.onProviderInportDialog = true;
      this.loaderService.hideSecond();
      // this.reloadGrid();
      this.repeatSchedule = false;
      // this.scheduleTimezoneName = '';
    }, (error) => {
      this.onProviderInportDialog = true;
      this.fileInportHeader = 'File Import Error';
      this.loaderService.hideSecond();
      this.fileInportMsg = error.general[0].message;
      this.repeatSchedule = false;
      //   this.scheduleTimezoneName = '';
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }

  convertToCssClass(className: string) {
    const lowerCaseClass = className.split(' ').map((name) => name.toLowerCase());
    return lowerCaseClass.join('-');
  }

  onChangeImport(event) {
    if (event.value === true) {
      this.repeatSchedule = true;
    }
  }

  showExport() {
    this.exportPopup = true;
    this.fromDate = new Date();
    const d = new Date(new Date().setHours(0, 0, 0, 0));
    d.setDate(d.getDate() + 30);
    this.toDate = d;
    if (this.roleId === '6' || this.roleId === '11') {
      this.providerIdExport = this.loginUserId;
    }
  }

  hideExport() {
    this.exportPopup = false;
    this.providerIdExport = '';
  }

  exportData() {
    const fromDateValue = moment(this.fromDate).format('MM/DD/YYYY');
    const toDateValue = moment(this.toDate).format('MM/DD/YYYY');
    let urlNew = '';
    urlNew = '/secure/reports/schedules/export/xls?fromDate=' + fromDateValue + '&toDate=' +
      toDateValue + '&providerId=' + this.providerIdExport;
    this.manageOpenShiftsService.downloadExcelData(urlNew);
    this.hideExport();
  }

  // getProvider() {
  //   this.providerNameListExport = [];
  //   this.manageOpenShiftsService.getProvider().subscribe((result) => {
  //   const providerData = result;
  //   for (let i = 0; i < providerData.length; i++) {
  //     if (providerData[i].providerName !== null) {
  //       this.providerNameListExport.push({ label: providerData[i].providerName, value: providerData[i].id });
  //     }
  //   }
  //   }, (error) => {});
  // }

  exportToDateValidation() {
    const dayDiff = this.daysDiff();
    if (dayDiff > 30) {
      this.dateDiffFlag = false;
      this.uiService.showMessage('Maximum 30 days data will be loaded, please select to date properly.',
        AppSettings.MESSAGE_TYPES.ERROR);
      return;
    } else {
      this.dateDiffFlag = true;
    }
  }

  daysDiff() {
    const date1: any = this.fromDate;
    const date2: any = this.toDate.setHours(0, 0, 0, 0);
    const diffTime = Math.abs(date2 - date1);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  }

  sendReportEmail() {
    const fromDateValue = moment(this.fromDate).format('MM/DD/YYYY');
    const toDateValue = moment(this.toDate).format('MM/DD/YYYY');
    this.exportUrlViaEmail = '/secure/reports/add-job?fromDateStr=' + fromDateValue + '&toDateStr=' + toDateValue + '&searchText=' + '&emailId=' + this.userEmail + '&name=' + this.userName + '&reportType=' + 'PROVIDER_SCHEDULE';
    this.manageOpenShiftsService.exportReportXLS(this.exportUrlViaEmail).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }

  saveFilter() {
    const filterObj = {
      'date': new Date(this.date).getTime(),
      'selectedAvailability': this.selectedAvailability,
      'selectedRole': this.selectedRole,
      'userRoleIds': this.userRoleIds,
      'providerId': this.providerId,
      'serviceRegionIds': this.selectedServiceRegionIds
    };
    const filterModel: any = {
      'userId': this.loginUserId,
      'filterType': 'TEAM_MEMBER_FILTER',
      'filterData': filterObj
    };

    this.manageOpenShiftsService.teamMemberSaveFilter(filterModel).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
      this.filterSavedFlag = true;
      localStorage.setItem('teamMemberFilterPresent', JSON.stringify(filterModel));
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }

  getFilter() {
    const type = 'TEAM_MEMBER_FILTER';
    this.manageOpenShiftsService.teamMemberGetFilter(this.loginUserId, type).subscribe(results => {
      this.FilterDataFlag = results.filterData;
      if (results.filterData !== null && results.filterData !== undefined) {
        const filterDataResults = JSON.parse(results.filterData);
        this.filterSavedFlag = true;
        if (filterDataResults?.selectedAvailability) {
          this.selectedAvailability = filterDataResults?.selectedAvailability;
        }
        if (filterDataResults?.date !== 0 && filterDataResults?.date !== null) {
          this.date = new Date(filterDataResults?.date);
        }
        if (filterDataResults?.providerId && !this.disableProvider) {
          this.providerId = filterDataResults?.providerId;
        }
        this.ensureProviderIdForRole();
        if (filterDataResults?.selectedRole) {
          this.selectedRole = filterDataResults?.selectedRole;
        }
        if (filterDataResults?.userRoleIds) {
          if (this.selectedRole === '20') {
          this.showRole = true;
          }
          setTimeout(() => {
            const selectedRoleIds = filterDataResults.userRoleIds;
            this.userRoleIds = selectedRoleIds;
          }, 500);

        }
        if (filterDataResults?.serviceRegionIds) {
          this.selectedServiceRegionIds = filterDataResults.serviceRegionIds;
        }
        this.loadServiceRegions(filterDataResults?.serviceRegionIds, true);
        this.getFilterLocal(filterDataResults);
      }
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }

  getRoles() {
    // this.roles.push({ label: this.commonService.getLabel('All'), value: '' });
    this.manageOpenShiftsService.getLoginUserRoles().subscribe((results) => {
      for (let role = 0; role < results.length; role++) {
        this.roles.push({ label: results[role].roleName, value: results[role].id });
      }
      // this.userRoleIds = this.roles && this.roles.length > 0 ? this.roles[i].value : null;
      if (this.selectedRole === '20') {
        this.showRole = true;
        // for (let i = 0; i <= this.roles.length; i++) {
        //   if (this.roles[i].value === this.selectedRoleId) {
        //     this.userRoleIds = this.roles[i].value;
        //   }
        // }
      }
    });
  }

  getFilterLocal(results) {
    if (results !== null && results !== undefined) {
      const filterDataResults = results;
      this.filterSavedFlag = true;
      if (filterDataResults?.selectedAvailability) {
        this.selectedAvailability = filterDataResults?.selectedAvailability;
      }
      if (filterDataResults?.date !== 0 && filterDataResults?.date !== null) {
        this.date = new Date(filterDataResults?.date);
      }
      if (filterDataResults?.selectedRole) {
        this.selectedRole = filterDataResults?.selectedRole;
      }
      if (filterDataResults?.providerId && !this.disableProvider) {
        this.providerId = filterDataResults?.providerId;
      }
      this.ensureProviderIdForRole();
      if (filterDataResults?.serviceRegionIds) {
        this.selectedServiceRegionIds = filterDataResults.serviceRegionIds;
      }
      if (filterDataResults?.userRoleIds) {
        const selectedRoleIds = filterDataResults.userRoleIds;
        this.userRoleIds = selectedRoleIds;
      }
      if (filterDataResults.date > this.currentDate || this.currentDate > filterDataResults.date ) {
        this.isDateChanged = true;
      } else {
        this.isDateChanged = false;
      }
    }
  }

  filterChange() {
    this.offset = 0;
  }

  loadServiceRegions(savedRegionIds?: any[], refresh = false) {
    const regions$ = this.providerId
      ? this.commonService.getServiceRegionsByProviderID(this.providerId)
      : this.commonService.getServiceRegions();

    regions$.subscribe((regions) => {
      this.serviceRegionList = this.commonService.mapServiceRegionOptions(regions);
      if (savedRegionIds && savedRegionIds.length) {
        this.selectedServiceRegionIds = savedRegionIds.filter((id) =>
          this.serviceRegionList.some((region) => region.value === id)
        );
      } else if (this.selectedServiceRegionIds.length) {
        this.selectedServiceRegionIds = this.selectedServiceRegionIds.filter((id) =>
          this.serviceRegionList.some((region) => region.value === id)
        );
      }
      if (refresh) {
        this.filterChange();
      }
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }

  onProviderChange() {
    this.loadServiceRegions(undefined, true);
  }

  private applyProviderRoleScope() {
    const roleId = this.storageService.getItem<number>(AppSettings.USER_ROLE_ID);
    if (roleId === AppSettings.PROVIDER_ROLE_ID || roleId === 11) {
      this.disableProvider = true;
      this.providerId = this.loginUserId;
    }
  }

  private ensureProviderIdForRole() {
    if (this.disableProvider && this.loginUserId) {
      this.providerId = this.loginUserId;
    }
  }

}


